module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"principal":"Principal","interest":"Interest","penalty":"Penalty","fee":"Fee","vat":"VAT"},"et":{"principal":"Principal","interest":"Interest","penalty":"Penalty","fee":"Fee","vat":"VAT"},"ru":{"principal":"Principal","interest":"Interest","penalty":"Penalty","fee":"Fee","vat":"VAT"}}')
  delete Component.options._Ctor
}
